import { render, staticRenderFns } from "./CollectifAdmin.vue?vue&type=template&id=4f4952e4&scoped=true&"
import script from "./CollectifAdmin.vue?vue&type=script&lang=js&"
export * from "./CollectifAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4952e4",
  null
  
)

export default component.exports